/**
 * Event types the user can filter by, grouped into the sections shown in the
 * filters panel. Every group key and every entry needs an `events.<key>` label
 * in locize — an event missing from here is invisible in User Activity.
 *
 * Keep it in sync with the `Event` union in `api/src/types/events.ts`.
 */
export const filtersAndSubfilters = {
  account: ["account_created", "account_updated", "account_deleted"],
  copy_policy: [
    "copy_policy_created",
    "copy_policy_updated",
    "copy_policy_deleted",
  ],
  dataset: ["dataset_created", "dataset_updated", "dataset_deleted"],
  domain: ["domain_created", "domain_updated", "domain_deleted"],
  filter_policy: [
    "filter_policy_created",
    "filter_policy_updated",
    "filter_policy_deleted",
  ],
  group: ["group_deleted"],
  malware: ["malware_released"],
  organization: ["organization_updated"],
  rule: [
    "rule_created",
    "rule_updated",
    "rule_deleted",
    "rule_enabled",
    "rule_disabled",
  ],
  security: ["security_updated"],
  security_definition: [
    "security_definition_created",
    "security_definition_updated",
    "security_definition_deleted",
  ],
  security_policy: [
    "security_policy_created",
    "security_policy_updated",
    "security_policy_deleted",
  ],
  source: ["source_created", "source_updated", "source_deleted"],
  storage: [
    "storage_account_created",
    "storage_account_reauthorized",
    "storage_account_deleted",
    "storage_settings_updated",
  ],
  template_definition: [
    "template_definition_created",
    "template_definition_updated",
    "template_definition_deleted",
  ],
  template_policy: [
    "template_policy_created",
    "template_policy_updated",
    "template_policy_deleted",
  ],
  user: [
    "user_created",
    "user_updated",
    "user_deleted",
    "login",
    "reset_password",
    "role_updated",
  ],
  variable: ["variable_created", "variable_updated", "variable_deleted"],
};

export const filters = Object.keys(filtersAndSubfilters);
